// extracted by mini-css-extract-plugin
export var three = "styles-module--three--3qJsU";
export var item = "styles-module--item--VofC5";
export var terms = "styles-module--terms--2H4hT";